/* Native scroll-snap story gallery. No autoplay or purchase-flow dependencies. */
(() => {
  const key = '__dirtlejStoryGalleries';
  if (window[key]) return;
  const controllers = new Map();
  window[key] = controllers;
  function attach(root) {
    if (controllers.has(root)) return;
    const track = root.querySelector('[data-story-track]');
    const frames = [...root.querySelectorAll('[data-story-frame]')];
    const tools = root.querySelector('[data-story-tools]');
    if (!track || frames.length < 2 || !tools) return;
    const previous = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    const counter = root.querySelector('[data-story-count]');
    const progress = root.querySelector('[data-story-progress]');
    const abort = new AbortController();
    let selected = -1, pending = 0;
    const update = () => {
      pending = 0;
      const bounds = track.getBoundingClientRect();
      const rtl = getComputedStyle(track).direction === 'rtl';
      const start = rtl ? bounds.right : bounds.left;
      let index = 0, best = Infinity;
      frames.forEach((frame, position) => {
        const rect = frame.getBoundingClientRect();
        const distance = Math.abs((rtl ? rect.right : rect.left) - start);
        if (distance < best) { best = distance; index = position; }
      });
      if (selected !== index) {
        selected = index;
        counter.textContent = String(index + 1);
        previous.disabled = index === 0;
        next.disabled = index === frames.length - 1;
        progress.style.setProperty('--dlj-story-progress',((index + 1) / frames.length * 100) + '%');
        frames.forEach((frame, position) => {
          frame.toggleAttribute('data-current',position === index);
          if (position !== index) frame.querySelectorAll('video').forEach(video => video.pause());
        });
      }
    };
    const schedule = () => { if (!pending) pending = requestAnimationFrame(update); };
    const go = index => {
      index = Math.max(0,Math.min(frames.length - 1,index));
      const rtl = getComputedStyle(track).direction === 'rtl';
      const rect = frames[index].getBoundingClientRect();
      const bounds = track.getBoundingClientRect();
      const delta = rtl ? rect.right - bounds.right : rect.left - bounds.left;
      track.scrollBy({left:delta,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click',() => go(selected - 1),{signal:abort.signal});
    next.addEventListener('click',() => go(selected + 1),{signal:abort.signal});
    track.addEventListener('scroll',schedule,{signal:abort.signal,passive:true});
    track.addEventListener('keydown',event => {
      if (event.target !== track) return;
      let target;
      const rtl = getComputedStyle(track).direction === 'rtl';
      if (event.key === 'ArrowRight') target = selected + (rtl ? -1 : 1);
      if (event.key === 'ArrowLeft') target = selected + (rtl ? 1 : -1);
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = frames.length - 1;
      if (target !== undefined) { event.preventDefault(); go(target); }
    },{signal:abort.signal});
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    resize?.observe(track);
    window.addEventListener('resize',schedule,{signal:abort.signal,passive:true});
    root.classList.add('is-enhanced'); tools.hidden = false; update();
    controllers.set(root,{destroy(){
      abort.abort(); resize?.disconnect();
      if (pending) cancelAnimationFrame(pending);
      frames.forEach(frame => frame.querySelectorAll('video').forEach(video => video.pause()));
      root.classList.remove('is-enhanced'); tools.hidden = true;
      controllers.delete(root);
    }});
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-dlj-story-gallery]')) attach(scope);
    scope.querySelectorAll('[data-dlj-story-gallery]').forEach(attach);
  }
  scan();
  document.addEventListener('shopify:section:load',event => scan(event.target));
  document.addEventListener('shopify:section:unload',event => {
    controllers.forEach((controller,root) => {
      if (event.target === root || event.target.contains(root)) controller.destroy();
    });
  });
})();
